import { render, staticRenderFns } from "./RemortgageCaseCard.vue?vue&type=template&id=1d7aa8ca&"
import script from "./RemortgageCaseCard.vue?vue&type=script&lang=js&"
export * from "./RemortgageCaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports